import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { ArrowLeft, Clock, MapPin, Tv, User } from "lucide-react";
import TVEpisodeCard from "../components/TVEpisodeCard";

export default function TVEpisode() {
  const { id } = useParams();
  const [ep, setEp] = useState(null);
  const [all, setAll] = useState([]);

  useEffect(() => {
    api.get(`/tv/episodes/${id}`).then((r) => setEp(r.data)).catch(() => setEp(null));
    api.get("/tv/episodes").then((r) => setAll(r.data || []));
  }, [id]);

  if (!ep) return <div className="container-xl py-20 text-center text-white/60 bg-black min-h-screen">Caricamento…</div>;

  // Build embed URL (support youtube.com/watch?v=, youtu.be/, embed/)
  const embedUrl = (() => {
    const u = ep.video_url || "";
    const ytMatch = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]+)/);
    if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;
    return u;
  })();

  const related = all.filter((x) => x.id !== ep.id).slice(0, 3);

  return (
    <div data-testid="tv-episode-page" className="bg-black text-white min-h-screen">
      <div className="container-xl py-8 md:py-12">
        <Link to="/tv" className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.3em] text-white/60 hover:text-white mb-6">
          <ArrowLeft className="h-3.5 w-3.5" /> Torna ad Amazonico TV
        </Link>
        <div className="grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            {/* Video */}
            <div className="relative aspect-video bg-[#0a0a0a] rounded-sm overflow-hidden border border-white/10">
              <iframe
                data-testid="tv-episode-iframe"
                src={embedUrl}
                title={ep.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-full h-full"
              />
            </div>
            {/* Meta */}
            <div className="mt-6">
              <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.4em] text-[#C9A961] mb-2">
                <Tv className="h-3.5 w-3.5" /> S{ep.season || 1} · Episodio {ep.episode_number}
              </div>
              <h1 data-testid="tv-episode-title" className="editorial-heading text-3xl md:text-5xl leading-tight">{ep.title}</h1>
              <div className="mt-4 flex flex-wrap gap-5 text-sm text-white/70">
                <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" />{ep.region}</span>
                <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" />{ep.duration_min} min</span>
                {ep.host && <span className="flex items-center gap-1.5"><User className="h-3.5 w-3.5" />{ep.host}</span>}
                {ep.winery && <span>· {ep.winery}</span>}
              </div>
              <p className="mt-6 text-base md:text-lg text-white/85 leading-relaxed">{ep.description}</p>
              {Array.isArray(ep.tags) && ep.tags.length > 0 && (
                <div className="mt-6 flex flex-wrap gap-2">
                  {ep.tags.map((t) => (
                    <span key={t} className="px-3 py-1 text-[10px] uppercase tracking-[0.2em] bg-white/5 border border-white/10 text-white/80">{t}</span>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Related */}
          <aside>
            <div className="text-xs uppercase tracking-[0.3em] text-[#C9A961] mb-4">Altri episodi</div>
            <div className="space-y-4">
              {related.map((r) => (<TVEpisodeCard key={r.id} ep={r} />))}
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}
